<div
  class="delete-role-dialog">
  <h2 class="headline">{{'VIRTUAL_POS_PAGE.MODAL_DELETE.TITLE' | translate}}</h2>
  <p class="description">{{'VIRTUAL_POS_PAGE.MODAL_DELETE.DESCRIPTION' | translate}}</p>
  <h3 class="subtitle">ID {{deleteId}}</h3>
  <div class="btn-block">
    <button
      (click)="deleteCash()"
      class="btn btn-danger">
      {{'VIRTUAL_POS_PAGE.MODAL_DELETE.DELETE' | translate}}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{'VIRTUAL_POS_PAGE.MODAL_DELETE.CANCEL' | translate}}
    </button>
  </div>
</div>
